import * as React from 'react';

import './style.css';

interface Props {
  channelLogin: string;
}

interface State {}

export class ChatPlayer extends React.Component<Props, State> {
  public render() {
    return (
      <div className="clipping">
        <iframe className="embeddedChat" src={`https://www.twitch.tv/${this.props.channelLogin}/chat`} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/chat-player/component.tsx